import { useState, useEffect } from 'react';

export function useDebounce(value:unknown, delay:number) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    // 1. Set up a timer to update our value after the specified delay
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // 2. Cleanup: If 'value' or 'delay' changes before the timer finishes, 
    // this cancels the previous timer and starts a fresh one.
    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}